import baseAPI from '@/api/base';
import {
  EditRecentPhoto,
  GetRecentPhoto,
  RegisterRecentPhoto,
} from '@/dtos/recent_photo.dto';
import {
  DELETE_RECENT_PHOTO_URL,
  EDIT_RECENT_PHOTO_URL,
  GET_RECENT_PHOTO_URL,
  REGISTER_RECENT_PHOTO_URL,
  TOGGLE_RECENT_PHOTO_IS_ACTIVE_URL,
} from '@/utils/urls';
import { AxiosResponse } from 'axios';

class RecentPhoto {
  static getRecentPhotos = async (
    getRecentPhoto: GetRecentPhoto
  ): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.get(GET_RECENT_PHOTO_URL, {
      params: getRecentPhoto,
    });
    console.log('response', response);
    return response;
  };

  static registerRecentPhoto = async (
    formData: FormData
  ): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.post(
      REGISTER_RECENT_PHOTO_URL,
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      }
    );
    console.log('response', response);
    return response;
  };

  static editRecentPhoto = async (
    formData: FormData
  ): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.put(
      EDIT_RECENT_PHOTO_URL,
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      }
    );
    return response;
  };

  static toggleRecentPhotoIsActive = async (
    editRecentPhoto: EditRecentPhoto
  ): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.patch(
      TOGGLE_RECENT_PHOTO_IS_ACTIVE_URL,
      {
        ...editRecentPhoto,
      }
    );
    return response;
  };

  static deleteRecentPhoto = async (
    id: string
  ): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.delete(
      `${DELETE_RECENT_PHOTO_URL}/${id}`
    );
    return response;
  };
}

export default RecentPhoto;
